<div class="drawer-wrapper">
  <div class="offcanvas-header user-info-wrapper gap-1">
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="offcanvas"
    ></button>

    <div class="flex-grow-1"></div>

    @if (userInfo) {
      <span>{{ userInfo.userNm }}{{ 'sir' | translate }}</span>
      <!-- 잔여 포인트 -->
      <ng-container *feature="'userInfo_point'">
        <span class="point">{{ userCard?.prpayAmt | number }}P</span>
        <!-- 정보 갱신 버튼 -->
        <button
          type="button"
          class="btn refresh"
          (click)="onRefreshInfoButtonClick()"
          >
          <i class="bi bi-arrow-clockwise"></i>
        </button>
      </ng-container>
    } @else {
      <span>{{ 'key-31' | translate }}</span>
    }

  </div>

  <div class="login-wrapper">
    @if (userInfo) {
      <div
        class="login-button"
        (click)="onLogoutClick()"
        data-bs-dismiss="offcanvas"
        >
        {{ 'logout' | translate }}
      </div>
      <div
        class="login-button"
        routerLink="/my/change-info"
        data-bs-dismiss="offcanvas"
        >
        {{ 'changeUserInfo' | translate }}
      </div>
    } @else {
      <div
        class="login-button"
        (click)="onLoginClick()"
        data-bs-dismiss="offcanvas"
        >
        {{ 'login' | translate }}
      </div>
      @if (canRegister) {
        <div
          class="login-button"
          (click)="onRegisterClick()"
          data-bs-dismiss="offcanvas"
          >
          {{ 'key-32' | translate }}
        </div>
      }
    }

  </div>

  <ng-container *homeScreen="'showMembershipMenuFlg'">
    <ng-container *feature="'userInfo_point'">
      <div class="login-wrapper">
        <div
          class="login-button"
          routerLink="/my/prpay"
          data-bs-dismiss="offcanvas"
          >
          {{ 'Membership' | translate }}
        </div>
      </div>
    </ng-container>
  </ng-container>

  <div
    class="booking-list-menu"
    routerLink="/my-info"
    data-bs-dismiss="offcanvas"
    >
    @if (isEtcBrand()) {
      {{ 'rsrvHist' | translate }}
    } @else {
      {{ 'consultationHistory' | translate }}
    }
  </div>

  <div class="menu-container">
    @for (menu of menuListNew; track menu) {
      @if (isMenuVisibleByBreakpoint(menu.breakpointToShow)) {
        <!-- 메뉴 타입 'URL'일때 동작 -->
        @if (menu.type === 'url') {
          <!-- URL 주소가 '/'으로 시작하면 내부 주소로 판단 -->
          @if (menu.url?.startsWith('/')) {
            <!-- 내부 링크 -->
            <div
              class="menu-wrapper"
              routerLinkActive="on"
              [routerLink]="menu.url"
              data-bs-dismiss="offcanvas"
              >
              {{ menu.title! | translate }}
              <i class="bi bi-chevron-right menu-icon"></i>
            </div>
          } @else {
            <!-- 외부 링크 -->
            <a target="_blank" [href]="menu.url">
              <div class="menu-wrapper" data-bs-dismiss="offcanvas">
                {{ menu.title! | translate }}
                <i class="bi bi-box-arrow-up-right menu-icon"></i>
              </div>
            </a>
          }
        } @else {
          <!-- 'URL'외 타입들은 메뉴 페이지에서 처리 -->
          <div
            class="menu-wrapper"
            routerLinkActive="on"
            queryParamsHandling="merge"
            [routerLink]="['menu', menu.id]"
            data-bs-dismiss="offcanvas"
            >
            {{ menu.title! | translate }}
            <i class="bi bi-chevron-right menu-icon"></i>
          </div>
        }
      }
    }

    <!-- 내부 링크 -->
    <!-- <div
    class="menu-wrapper"
    routerLinkActive="on"
    routerLink="/notice"
    data-bs-dismiss="offcanvas"
    >
    {{ 'notice' | translate }}

    <i class="bi bi-chevron-right menu-icon"></i>
  </div> -->
</div>

<!-- 언어 변경 -->
<div>
  <select
    class="form-select rounded-0"
    [ngModel]="lang"
    (ngModelChange)="onChangeLanguage($event)"
    >
    @for (language of languageList; track $index) {
      @if (isSupportedLanguage(language.code)) {
        <option class="notranslate" [value]="language.code">
          {{ language.name }}
        </option>
      }
    }
  </select>
</div>
</div>
